import { jsxs as E, jsx as u } from "react/jsx-runtime";
import { d as L, B as N, b as k, a as x } from "./Button-CKYuAByy.mjs";
const D = "_button_rmjdl_13", I = "_button__icon_rmjdl_47", P = "_button_dark_rmjdl_57", R = "_button_secondary_rmjdl_62", h = "_button_isWide_rmjdl_116", y = "_button_hasIconLeft_rmjdl_120", v = "_button_small_rmjdl_124", O = "_button_isDisabled_rmjdl_136", n = {
  button: D,
  button__icon: I,
  button_dark: P,
  button_secondary: R,
  button_isWide: h,
  button_hasIconLeft: y,
  button_small: v,
  button_isDisabled: O
};
var W = /* @__PURE__ */ ((t) => (t._SELF = "_self", t._BLANK = "_blank", t._PARENT = "_parent", t._TOP = "_top", t))(W || {}), A = /* @__PURE__ */ ((t) => (t.NOOPENER = "noopener", t.NOREFERRER = "noreferrer", t.EXTERNAL = "external", t))(A || {});
function S({
  id: t,
  uid: s,
  href: a,
  children: l,
  icon: r,
  hasIconLeft: i,
  isWide: c,
  ariaLabel: d,
  isDisabled: e,
  onAfterClickAndRedirect: b,
  target: _ = "_self",
  variant: m = N.PRIMARY,
  mode: p = x.LIGHT,
  size: f = k.DEFAULT
}) {
  const j = {
    id: t,
    uid: s,
    href: a,
    target: _,
    // hardcoding rel based on target
    rel: _ !== "_self" ? "external noopener noreferrer" : "",
    className: L(
      n.button,
      n[`button_${m}`],
      n[`button_${f}`],
      n[`button_${p}`],
      {
        [n.button_isWide]: c,
        [n.button_hasIconLeft]: i,
        [n.button_isDisabled]: e
      }
    ),
    "aria-label": d
  };
  return /* @__PURE__ */ E("a", { ...j, role: "link", onClick: async (o) => {
    if (e) {
      o.preventDefault(), o.stopPropagation();
      return;
    }
    b && (o.preventDefault(), o.stopPropagation(), await b(o, {
      id: t,
      uid: s,
      target: _,
      href: a
    }));
  }, children: [
    r && /* @__PURE__ */ u("span", { className: n.button__icon, children: r }),
    /* @__PURE__ */ u("span", { className: n.button__text, children: l })
  ] });
}
export {
  S as ButtonLink,
  A as ButtonRel,
  W as ButtonTarget
};
